import { Component } from '@angular/core';
import { OrderCompleteBaseComponent} from '@moduurnv2/libs-orderingapp/src';
import { Location } from '@angular/common';
import { Store } from '@ngxs/store';
import {
  FormBuilder,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  SweetAlertService,
  SharedService,
  VenueManagementService,
} from '@moduurnv2/libs-orderingapp/src/core';

import { MessagingService } from '@moduurnv2/web/core/services/messaging-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import {ModalService} from '@moduurnv2/web/features/ui/components/modal/modal.service';

@Component({
  selector: 'wj-customer-info',
  templateUrl: './customer-info.component.html',
  styleUrls: ['./customer-info.component.scss'],
})
export class CustomerInfoComponent extends OrderCompleteBaseComponent{

  constructor(
    protected fb: FormBuilder,
    public store: Store,
    public router: Router,
    public sweetAlert: SweetAlertService,
    public messagingService: MessagingService,
    public spinner: NgxSpinnerService,
    public shared: SharedService,
    public translate: TranslateService,
    public _location: Location,
    venueManagementService: VenueManagementService,
    modal: ModalService
  ) {

    super(
      fb,
      store,
      router,
      sweetAlert,
      spinner,
      shared,
      venueManagementService,
      modal,
      messagingService
    );
  }

  getCardDetails() {}

  validateAndConfirmOrder(){
      this.confirmOrder();
  }
}
